"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = setResponsiveStyles;
exports.styledComponentsResponsiveStyles = styledComponentsResponsiveStyles;
var _selectors = require("../components/Theme/selectors");
function setResponsiveStyles(uiTheme, responsive, styleFunction) {
  var style = {};
  responsive.map(function (breakpoint) {
    var minWidthKey = breakpoint.minWidth,
      maxWidthKey = breakpoint.maxWidth,
      _breakpoint$props = breakpoint.props,
      breakpointProps = _breakpoint$props === void 0 ? {} : _breakpoint$props;
    var minBreakpoint = (0, _selectors.getBreakpoint)(uiTheme, minWidthKey);
    var maxBreakpoint = (0, _selectors.getBreakpoint)(uiTheme, maxWidthKey);
    var breakpointStyles = styleFunction(breakpointProps);
    if (minBreakpoint && maxBreakpoint) {
      style["@media screen and (min-width: ".concat(minBreakpoint, "px) and (max-width: ").concat(maxBreakpoint, "px)")] = breakpointStyles;
    } else if (minBreakpoint) {
      style["@media screen and (min-width: ".concat(minBreakpoint, "px)")] = breakpointStyles;
    } else if (maxBreakpoint) {
      style["@media screen and (max-width: ".concat(maxBreakpoint, "px)")] = breakpointStyles;
    }
    return breakpoint;
  });
  return style;
}
function styledComponentsResponsiveStyles(uiTheme, responsive, styleFunction) {
  var style = '';
  if (!Array.isArray(responsive) || responsive.length === 0) {
    return style;
  }
  responsive.map(function (breakpoint) {
    var minWidthKey = breakpoint.minWidth,
      maxWidthKey = breakpoint.maxWidth,
      _breakpoint$props2 = breakpoint.props,
      breakpointProps = _breakpoint$props2 === void 0 ? {} : _breakpoint$props2;
    var minBreakpoint = (0, _selectors.getBreakpoint)(uiTheme, minWidthKey);
    var maxBreakpoint = (0, _selectors.getBreakpoint)(uiTheme, maxWidthKey);
    var breakpointStyles = styleFunction(breakpointProps);
    if (minBreakpoint && maxBreakpoint) {
      style += "@media screen and (min-width: ".concat(minBreakpoint, "px) and (max-width: ").concat(maxBreakpoint, "px) {\n        ").concat(breakpointStyles, "\n      }");
    } else if (minBreakpoint) {
      style += "@media screen and (min-width: ".concat(minBreakpoint, "px) {\n        ").concat(breakpointStyles, "\n      }");
    } else if (maxBreakpoint) {
      style += "@media screen and (max-width: ".concat(maxBreakpoint, "px) {\n        ").concat(breakpointStyles, "\n      }");
    }
    return breakpoint;
  });
  return style;
}